import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: { 
    title: 'New Reward Created!',
    svg_type: 'checkmark',
    message: 'redirecting...',
    visible: false,
  },
  mutations,
  actions,
  getters,
}